import { render, staticRenderFns } from "./SetFarmersInfoDialog.vue?vue&type=template&id=9f27e3bc&scoped=true&"
import script from "./SetFarmersInfoDialog.vue?vue&type=script&lang=js&"
export * from "./SetFarmersInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f27e3bc",
  null
  
)

export default component.exports